package com.exura.features.plandefinition.usecase

import com.exura.features.plandefinition.domain.repository.ProviderVersionedTreatmentRepository

class DeleteTreatmentPlanUseCase(
    private val repository: ProviderVersionedTreatmentRepository
) {
    suspend operator fun invoke(id: String): Result<Boolean> = repository.delete(id)
}
